module.exports = __webpack_public_path__ + "img/pr-16.ff54d2b5.png";